import type { RefObject } from 'react';
import {
  connectVoiceClient,
  getVoiceConnectionOptions,
  VoicePreference,
} from '../../services/cxone-sdk.service';
import { logger } from '../../utils/logger';

export async function connectCxoneVoiceIfNeeded(
  preference: VoicePreference,
  cxoneAgentId: string,
  audioRef: RefObject<HTMLAudioElement>
): Promise<string | null> {
  if (preference.type !== 'softphone') {
    logger.debug('[CXone] Using phone/station mode, skipping WebRTC voice client');
    return null;
  }

  const voiceOptions = await getVoiceConnectionOptions();
  logger.debug('[CXone] Voice options received:', voiceOptions);

  const hasWebRtcConfig =
    (voiceOptions.webRTCWssUrls && voiceOptions.webRTCWssUrls.length > 0) ||
    Boolean(voiceOptions.webRtcServerUrl);

  await new Promise((resolve) => setTimeout(resolve, 100));

  if (audioRef.current && hasWebRtcConfig) {
    logger.debug('[CXone] Connecting voice client with WebRTC config...');
    await connectVoiceClient(
      cxoneAgentId,
      voiceOptions,
      audioRef.current,
      process.env.REACT_APP_NAME || 'SAP-NICE Agent Widget'
    );
    return null;
  }

  if (!audioRef.current) {
    return 'Audio element not ready. Refresh and allow audio permissions.';
  }

  return 'Missing WebRTC configuration for voice connection.';
}
